import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./Motion";

const BookPromo = ({ compact = false }) => {
  const { lang, t } = useLanguage();
  const b = t.home.book;
  const coverSrc = lang === "en" && b.coverEn ? b.coverEn : b.cover;
  const linkHref = lang === "en" && b.linkEn ? b.linkEn : b.link;
  return (
    <Reveal>
      <div
        data-testid={compact ? "book-promo-compact" : "book-promo"}
        className={`grid items-center gap-10 overflow-hidden rounded-2xl border border-slate-200 bg-mist lg:grid-cols-12 ${
          compact ? "mt-10 p-8 md:p-10" : "p-8 md:p-14"
        }`}
      >
        <div className="flex justify-center lg:col-span-4">
          <motion.img
            src={coverSrc}
            alt={b.title}
            data-testid="book-cover-image"
            loading="lazy"
            whileHover={{ rotate: 0, scale: 1.03 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className={`-rotate-2 rounded-lg shadow-2xl ${compact ? "w-40 md:w-44" : "w-52 md:w-64"}`}
          />
        </div>
        <div className="lg:col-span-8">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent px-3.5 py-1.5 font-mono text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-white">
            {b.badge}
          </span>
          <h2
            className={`mt-5 max-w-xl font-display font-semibold leading-snug tracking-tight text-ink ${
              compact ? "text-xl sm:text-2xl" : "text-2xl sm:text-3xl lg:text-4xl"
            }`}
          >
            {b.title}
          </h2>
          <p className="mt-2 font-display text-lg font-medium text-navy">{b.subtitle}</p>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">{b.text}</p>
          <p className="mt-5 font-mono text-[0.65rem] uppercase tracking-[0.22em] text-slate-400">
            {b.authors}
          </p>
          <a
            href={linkHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={compact ? "book-amazon-cta-compact" : "book-amazon-cta"}
            className="group mt-7 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-navy-dark"
          >
            {b.cta}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </Reveal>
  );
};

export default BookPromo;
